import React, { useState } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ImageModal from 'Components/ImageModal';

const pageStyles = (theme) => ({
  productInformation: {
    paddingLeft: '50px',
    width: '54%',
    display: 'inline-block',
  },
  productCheckbox: {
    marginRight: '17px',
    marginLeft: '-50px',
  },
  productDescription: {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: '16px',
    lineHeight: '23px',
    marginTop: 0,
  },
  productPrice: {
    color: '#45A358',
    fontWeight: 900,
  },
  productQuantityContainer: {
    '& .MuiFormLabel-root': {
      fontSize: '16px',
    },
    '& .MuiSvgIcon-root': {
      width: '23px',
    },
    '& .MuiSelect-root': {
      fontSize: '16px',
      lineHeight: '1.5',
    },
  },
  productQuantitySelect: {
    width: 55,
    marginBottom: 50,
  },
  image: {
    marginTop: '53px',
    width: 155,
    height: 155,
  },
});

const ItemReviewProduct = ({
  className,
  classes,
  checkboxName,
  isChecked,
  onChangeCheckbox,
  checkboxLabelText,
  numTags,
  dimensions,
  price,
  shipping,
  isQuantityDisabled,
  selectName,
  onChangeSelect,
  imageUrl,
  imageUrl2x,
  imageUrl3x,
  imageAltText,
  selectValue,
}) => {
  const [modalPreviewInformation, setModalPreviewInformation] = useState({});

  const priceWithShipping = (
    parseFloat(price, 10) + parseFloat(shipping, 10)
  ).toFixed(2);

  function onClickPreviewImage(imgSrc) {
    setModalPreviewInformation({
      imgSrc: imgSrc,
      fileName: null,
    });
  }

  return (
    <div className={className}>
      <div className={classes.productInformation}>
        <FormControlLabel
          control={
            <Checkbox
              name={checkboxName}
              checked={isChecked}
              className={classes.productCheckbox}
              onChange={onChangeCheckbox}
            />
          }
          label={checkboxLabelText}
          color="primary"
        />
        <p className={classes.productDescription}>
          {numTags > 1 && `${numTags}x stickers`}
          <br />
          {dimensions}
        </p>
        <p className={classes.productPrice}>{`$${priceWithShipping}`}</p>
        <FormControl
          className={classes.productQuantityContainer}
          disabled={isQuantityDisabled}
        >
          <InputLabel>Qty</InputLabel>
          <Select
            name={selectName}
            className={classes.productQuantitySelect}
            onChange={onChangeSelect}
            value={selectValue}
          >
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={2}>2</MenuItem>
            <MenuItem value={3}>3</MenuItem>
            <MenuItem value={4}>4</MenuItem>
            <MenuItem value={5}>5</MenuItem>
          </Select>
        </FormControl>
      </div>
      <img
        className={classes.image}
        src={imageUrl}
        alt={imageAltText}
        onClick={() => {
          onClickPreviewImage(imageUrl3x);
        }}
      />
      <ImageModal
        modalImageInformation={modalPreviewInformation}
        onClickCloseModal={() => setModalPreviewInformation({})}
        maxWidth="lg"
      />
    </div>
  );
};

export default withStyles(pageStyles)(ItemReviewProduct);
